var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChoosekaamvala4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2674_5461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.3865 15.0807V47.1913C94.3865 55.1389 90.7438 64.3638 84.1322 73.1669C76.4268 83.4232 65.0768 92.4763 51.3087 99.3476L50 100L48.6914 99.3476C34.9233 92.4763 23.5732 83.4232 15.8678 73.1669C9.25625 64.3638 5.61353 55.1389 5.61353 47.1913V15.0807L27.2081 0H72.7919L94.3865 15.0807Z",
    fill: "#00358F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3865 15.0807V47.1913C94.3865 55.1389 90.7438 64.3638 84.1322 73.1669C76.4268 83.4232 65.0768 92.4763 51.3086 99.3476L50 100V0H72.7919L94.3865 15.0807Z",
    fill: "#012453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1043 11.7188H30.8958L17.3328 21.1898V47.1908C17.3328 56.1267 26.1241 73.5884 50.0001 86.7979C73.876 73.5884 82.6674 56.1267 82.6674 47.1908V21.1898L69.1043 11.7188Z",
    fill: "#00B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6673 21.1898V47.1908C82.6673 56.1267 73.8759 73.5884 50 86.7979V11.7188H69.1043L82.6673 21.1898Z",
    fill: "#0274F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1643 26.0958C56.0725 24.004 53.1837 22.709 50 22.709C46.9237 22.709 44.0251 23.9141 41.8395 26.0997C39.6539 28.2854 38.4487 31.1839 38.4487 34.2602V42.1883H61.5512V34.2602C61.5512 31.0745 60.2562 28.1877 58.1643 26.0958ZM55.6916 38.5416H44.3083V34.2602C44.3083 32.7504 44.9041 31.3226 45.9822 30.2425C46.5116 29.7123 47.1392 29.2904 47.83 29.0002C48.5097 28.717 49.2441 28.5686 50 28.5686C53.1388 28.5686 55.6916 31.1214 55.6916 34.2602V38.5416Z",
    fill: "#FFB528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5512 34.2602V42.1883H50V38.5416H55.6916V34.2602C55.6916 31.1214 53.1388 28.5686 50 28.5686V22.709C53.1837 22.709 56.0725 24.004 58.1644 26.0958C60.2563 28.1877 61.5512 31.0745 61.5512 34.2602Z",
    fill: "#FE8C01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9272 36.3301H66.073V61.5908H33.9272V36.3301Z",
    fill: "#FEE158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 36.3301H66.0729V61.5908H50V36.3301Z",
    fill: "#FFB528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0261 8.78906H29.9738L14.4028 19.6625V47.191C14.4028 52.906 17.2975 60.168 22.3426 67.1136C28.4854 75.571 37.558 83.2646 48.5819 89.3625L49.9999 90.1477L51.418 89.3625C62.4418 83.2646 71.5144 75.571 77.6573 67.1136C82.7024 60.168 85.597 52.906 85.597 47.191V19.6625L70.0261 8.78906ZM79.7374 47.191C79.7374 54.9862 71.7859 70.9028 49.9999 83.4346C28.2139 70.9028 20.2624 54.9862 20.2624 47.191V22.7173L31.8176 14.6487H68.1823L79.7374 22.7173V47.191Z",
    fill: "#EFF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5971 19.6625V47.191C85.5971 52.906 82.7024 60.168 77.6573 67.1136C71.5145 75.571 62.4419 83.2646 51.418 89.3625L50 90.1477V83.4346C71.786 70.9028 79.7375 54.9862 79.7375 47.191V22.7173L68.1823 14.6487H50V8.78906H70.0262L85.5971 19.6625Z",
    fill: "#C6E1EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0703 45.9316H52.9299V51.9885H47.0703V45.9316Z",
    fill: "#FFB528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 45.9316H52.9298V51.9885H50V45.9316Z",
    fill: "#FE8C01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2674_5461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoosekaamvala4);
export default __webpack_public_path__ + "static/media/choosekaamvala4.724408a46aa75f445fb92b41fd98712c.svg";
export { ForwardRef as ReactComponent };